import bem from 'utils/bem';

export const block = bem('downgrade-upsell-modal');
